module.exports = {
    ENV: 'prod',
    APP_NAME: 'runeo',
    END_POINT: 'https://ssm.services.apihf.com',
    API_KEY: 'tZikzVTX731Vbxdk6d5Uua2EevtC6Cus3pRKSwre',
    BRAND_KEY: '4424c5d1-0924-4c86-8901-40bc42fcfa25',
    LANG: 'fr-FR'
}